import type { ColophonContent } from "../types";

export const colophon: ColophonContent = {
  linePrefix: "Made with",
  lineSuffix: "and UCloud AI.",
  finePrint:
    "AI-powered, human-led. Every token was computed in Denmark, never " +
    "used for training.",
};
